module.exports = __webpack_public_path__ + "static/media/Blokes-avatar-Amine-transparent.b13f53be.png";